// @flow
import React, { Component, Fragment } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import Select from '../controls/Select'
import LabeledWrapper from './LabeledWrapper'
import type { OptionType } from '../types'
import HintWrapper from '../controls/HintWrapper'
import { InputCell } from '../AudienceEdit'
import PricelistFormContainer from './PricelistFormContainer'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  align-items: center;
`
const SelectCell: StyledComponent<Object, any, any> = styled.div`
  flex: 100%;
`
const Delimiter: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  padding-left: 16px;
  padding-right: 16px;
`
const Link: StyledComponent<Object, any, any> = styled.a`
  font-size: 14px;
  border-bottom: 1px dashed #61b8d3;
  color: $link-color;
  text-decoration: blink;
`
const Item: StyledComponent<Object, any, any> = styled.div`
  font-family: 'PT Sans Caption', sans-serif;
`
const Spacer: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: 16px;
`

type Props = {|
  id: number | '',
  isDisabled: boolean,
  initialOptions: Array<OptionType>,
  initialName: string,
  options: Array<OptionType>,
  name: string,
  onInit: Function,
  onCreate: Function,
  onChange: Function
|}

const t = {
  set_pricelist: 'Задайте прайс-лист',
  label: 'Прайс-лист',
  placeholder: 'Выберите...',
  or: 'или',
  create: 'создайте',
  no_results: 'Ничего не найдено',
  pricelist_chosen: 'Использован прайслист',
  cant_replace_title: 'Невозможно изменить',
  cant_replace_description:
    'Создайте новую аудиторию, чтобы изменить настройки товарного ретаргетинга',
  no_pricelist: 'Товарный ретаргетинг не настроен'
}

export default class PricelistSelect extends Component<Props> {
  constructor(props: Props) {
    super(props)

    const initial = {
      name: this.props.initialName,
      options: this.props.initialOptions
    }
    props.onInit(initial)
  }

  render() {
    return this.props.isDisabled ? this.renderDisabledBlock() : this.renderPricelistSelectBlock()
  }

  renderPricelistSelectBlock() {
    return (
      <Fragment>
        <h2>{t.set_pricelist}</h2>
        <LabeledWrapper label={t.label}>
          <Wrapper className="t-PricelistSelect">
            <InputCell>
              <Wrapper>
                <SelectCell>
                  <Select
                    options={this.props.options}
                    value={this.props.id}
                    placeholder={t.placeholder}
                    noResultsText={t.no_results}
                    onChange={(id) => this.props.onChange(id)}
                  />
                </SelectCell>
                <Delimiter>{t.or}</Delimiter>
                <div>
                  <Link
                    onClick={(e) => {
                      e.preventDefault()
                      this.props.onCreate()
                    }}
                    href="#"
                  >
                    {t.create}
                  </Link>
                  <PricelistFormContainer />
                </div>
              </Wrapper>
            </InputCell>
          </Wrapper>
        </LabeledWrapper>
      </Fragment>
    )
  }

  renderDisabledBlock() {
    return (
      <Fragment>
        <h2>{t.pricelist_chosen}</h2>
        <label>
          <Item>
            {this.props.name || t.no_pricelist}
            <Spacer />
            <HintWrapper
              triggerText={t.cant_replace_title}
              popupText={t.cant_replace_description}
              alignLeft
              dashed
            />
          </Item>
        </label>
      </Fragment>
    )
  }
}
